import * as CONSTANTS from "../constants/actions/modal";

/**
 * @name INITIAL_STATE
 * @constant
 * @description
 * @type {Object}
 * @default
 */
const INITIAL_STATE = {
  isOpen: false,
  onConfirm: () => {},
  onCancel: () => {},
  modalIcon: null,
  modalTitle: "",
  modalMessage: "",
  modalConfirmMessage: "",
  haveFilter: false,
  haveDontAskAgain: false,
  haveActions: false,
  confirmState: null
};

/**
 * **DO NOT** Manipulate the state directly, always apply to a new object first!! If you don't redux will not
 * recognize a change in the data and the components will not receive the correct information.
 *
 * @name reducer
 * @function
 * @description Handles reduction of data accross components for the piece of the site implied by the filename
 * @param {Object} state Current state of the data
 * @param {Object} action Information passed from the corresponding actions file
 */
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONSTANTS.SHOW_MODAL:
      return {
        ...state,
        isOpen: true
      };
    case CONSTANTS.HIDE_MODAL:
      return {
        ...state,
        isOpen: false,
        onConfirm: () => {},
        onCancel: () => {},
        modalIcon: null,
        modalTitle: "",
        modalMessage: "",
        modalConfirmMessage: "",
        haveFilter: false,
        haveDontAskAgain: false,
        haveActions: false,
        confirmState: null
      };
    case CONSTANTS.SET_VALUES:
      return {
        ...state,
        onConfirm: action.payload.onConfirm,
        onCancel: action.payload.onCancel,
        modalIcon: action.payload.modalIcon,
        modalTitle: action.payload.modalTitle,
        modalMessage: action.payload.modalMessage,
        modalConfirmMessage: action.payload.modalConfirmMessage,
        haveFilter: action.payload.haveFilter,
        haveDontAskAgain: action.payload.haveDontAskAgain,
        haveActions: action.payload.haveActions,
        confirmState: action.payload.confirmState
      };
    default:
      return state;
  }
};

export default reducer;
